import * as React from 'react';
import Grid from '@mui/material/Grid';
import { ICustomerImage } from '../queries/CustomerDigitalStylingApi';
import { CustomerImage } from './CustomerImage';

type CustomerImagesProps = {
    images: ICustomerImage[];
};

export function CustomerImages({ images }: CustomerImagesProps) {
    return (
        <Grid container sx={{ height: '100%', paddingTop: '10px' }} spacing={2}>
            {images.map((image) => (
                <Grid item key={image.id} xs={12} sm={6} md={4} lg={3}>
                    <CustomerImage
                        id={image.id}
                        imageReference={image.reference}
                        highResolutionReference={image.highResolutionImageReference}
                        filename={image.filename}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
